import request from "superagent";
import { getAuthHeader } from "../../../utils/superagent";

const updateHCPStage = async ({ adminId, adminName, agentId, stage, substage, reason, note }) => {
  return request
    .put(`${global.api}/agentProfile/stage`)
    .set(await getAuthHeader())
    .send({
      adminId,
      adminName,
      agentId,
      stage,
      substage,
      reason,
      note,
    });
};

export { updateHCPStage };
